import React from 'react';
import Box from '@mui/material/Box';
import cn from 'classnames';

import { ROUTES } from '~constants/routes';
import { useIsRejectedOrderScreen } from '~hooks/useIsRejectedOrderScreen';
import { useIsTakeOrderScreen } from '~hooks/useIsTakeOrderScreen';

import Toolbar from '../Toolbar';

import Logo from './components/Logo';
import styles from './styles.module.scss';
import { Settings } from './components/Settings';
import SettingsSidebar from './components/SettingsSidebar';

const Navbar = () => {
  const isRejectedOrderScreen = useIsRejectedOrderScreen();
  const isTakeOrderScreen = useIsTakeOrderScreen();
  return (
    <nav
      id="navbarTop"
      className={cn(`row middle ${styles.navBar}`, {
        [styles.navBarRejectedOrderManager]: isRejectedOrderScreen
      })}>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 0,
          flexShrink: 0,
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className={styles.logoContainer}>
        <Logo homePath={ROUTES.HOME.basePath} />
      </Box>
      {isRejectedOrderScreen || isTakeOrderScreen ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%'
          }}>
          <Settings hideSettings />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}>
          <Toolbar />
          <Settings />
          <SettingsSidebar />
        </Box>
      )}
    </nav>
  );
};

export default Navbar;
